module.exports = __webpack_public_path__ + "static/media/applePayLogo.78525861.svg";